// extracted by mini-css-extract-plugin
export default {"link":"BNHCNw","image":"DKmRPX","root":"vOVDU8"};